import { Button } from '@/components/ui/button'
import * as Slider from '@/components/ui/slider'
import { DialogContainer } from '@components'
import { For, createEffect, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { Grid } from 'styled-system/jsx'
import { useSingle } from '../../state'
import { ActionButton } from './ActionButton'

const StarIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9 6.8 19.6l1-5.8L3.5 9.7l5.9-.9z" />
  </svg>
)

export const Score = (props: { size?: 'main' | 'mobile' }) => {
  const [score, setScore] = createSignal<number>()
  const { isArchived, setScore: saveScore, takenQuery, upsertTakenMutation, isScoreOpen, setIsScoreOpen } = useService(useSingle)()

  const handleScore = () => {
    const s = score()
    if (s) {
      saveScore(s)
    }
  }

  createEffect(() => {
    if (upsertTakenMutation.isSuccess) {
      setIsScoreOpen(false)
      upsertTakenMutation.reset()
    }
  })

  return (
    <>
      <ActionButton
        heading={takenQuery.data?.score ? 'Scored' : 'Score'}
        tooltip="Score this setup"
        active={!!takenQuery.data?.score}
        disabled={isArchived()}
        onClick={() => setIsScoreOpen(true)}
        icon={<StarIcon />}
        size={props.size}
      />
      <DialogContainer
        title="Score"
        isOpen={isScoreOpen()}
        setIsOpen={setIsScoreOpen}
      >
        <Grid
          gap={3}
        >

          <Slider.Root
            step={1}
            max={10}
            defaultValue={[takenQuery?.data?.score || 0]}
            onValueChange={({ value }) => setScore(value[0])}>
            <Slider.Control>
              <Slider.Track>
                <Slider.Range />
              </Slider.Track>
              <Slider.Thumb index={0}>
                <Slider.HiddenInput />
              </Slider.Thumb>
            </Slider.Control>
            <Slider.MarkerGroup mt={6}>
              <For each={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}>
                {(value) => (
                  <Slider.Marker value={value}>
                    {value}
                  </Slider.Marker>
                )}
              </For>
            </Slider.MarkerGroup>
          </Slider.Root>

          <Grid
            gridTemplateColumns="1fr 1fr"
            gap={3}
            mt={12}
          >
            <Button
              onClick={() => setIsScoreOpen(false)}
              variant="outline"
            >
              Cancel
            </Button>
            <Button
              loading={upsertTakenMutation.isPending}
              colorPalette="jade"
              variant="solid"
              onClick={handleScore}
            >
              Confirm
            </Button>
          </Grid>
        </Grid>
      </DialogContainer>
    </>
  )
}
